<template>
  <span
    v-if="!active"
    class="sc__val sc-edit"
    :class="{ 'is-disabled': disabled, 'is-blank': isBlank }"
    role="button"
    :tabindex="disabled ? -1 : 0"
    @click="activate"
    @keydown.enter.prevent="activate"
  >{{ display }}</span>
  <input
    v-else
    ref="inputEl"
    v-model="draft"
    class="sc-edit-input"
    :style="{ width: inputWidth }"
    :inputmode="numeric ? 'numeric' : undefined"
    :placeholder="placeholder"
    @blur="commit"
    @keydown.enter.prevent="commit"
    @keydown.esc.prevent="cancel"
  />
</template>

<script setup lang="ts">
import { computed, nextTick, ref } from 'vue'

/* 계약서 빈칸 — 평소에는 문서 텍스트, 누르면 그 자리에서 입력 */
const props = withDefaults(defineProps<{
  modelValue: string
  width?: number
  disabled?: boolean
  numeric?: boolean
  placeholder?: string
}>(), { width: 8, disabled: false, numeric: false, placeholder: '' })

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const active = ref(false)
const draft = ref('')
const inputEl = ref<HTMLInputElement | null>(null)

const isBlank = computed(() => !String(props.modelValue || '').trim())

const display = computed(() => {
  const t = String(props.modelValue || '').trim()
  if (t) return t
  return '　'.repeat(Math.min(props.width, 8))
})

const inputWidth = computed(() => `${Math.max(6, draft.value.length + 2)}ch`)

function activate() {
  if (props.disabled) return
  draft.value = String(props.modelValue || '')
  active.value = true
  nextTick(() => inputEl.value?.focus())
}

function commit() {
  if (!active.value) return
  active.value = false
  const v = draft.value.trim()
  if (v !== String(props.modelValue || '')) emit('update:modelValue', v)
}

function cancel() {
  active.value = false
}
</script>
